(function() {
  function load(src) {
    var s = document.createElement('script');
    s.src = src;
    s.async = false;
    document.head.appendChild(s);
  }

  if (!('fetch' in window)) {
    load('https://cdn.jsdelivr.net/npm/whatwg-fetch@3.6.2/dist/fetch.umd.js');
  }
  if (!('URLSearchParams' in window)) {
    load('https://cdn.jsdelivr.net/npm/url-search-params-polyfill@8.1.1/index.min.js');
  }
  if (!('customElements' in window)) {
    load('https://cdn.jsdelivr.net/npm/@webcomponents/custom-elements@1.4.3/custom-elements.min.js');
  }
})();